import React, {Component} from 'react';
import {Badge, Col, List, Row, Switch} from 'antd';
import _, {get, isEmpty} from 'lodash';
import Expand from "../../3th_party/Expand";
import CommonSetting from "./exchange_select/CommonSetting";
import Notification from "./exchange_select/Notification";
import consts from "../../consts";
import {Translation} from "react-i18next";
import {MoreOutlined, DownOutlined, ArrowUpOutlined , ArrowDownOutlined } from '@ant-design/icons'
import utils from "../../common/utils";

class ExchangeSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visibleDrawer: false,
      visibleDrawerNotify: false,
      totalCount: 0,
      totalCountAll: 0,
      loading: false,
    }

    this.filter = {
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
    }
    
    this.handleClickItem = this.handleClickItem.bind(this);
    this.toggleMarket = this.toggleMarket.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClickDrawer = this.handleClickDrawer.bind(this);
    this.handleClickDrawerNotify = this.handleClickDrawerNotify.bind(this);
    this.getBalance = this.getBalance.bind(this);
    this.getAvailableBalance = this.getAvailableBalance.bind(this);
    this.getSumBalance = this.getSumBalance.bind(this);
    this.node = {};
    this.drawer = {};
    this.drawerNotify = {};
  }
  
  handleClickItem(coin) {
    this.props.changeMarket(coin.coin, coin.currency);
    this.setState({visible: false});
  }
  
  toggleMarket() {
    this.setState({visible: !this.state.visible});
  }
  
  toggleDrawer = () => {
    this.setState({visibleDrawer: !this.state.visibleDrawer});
  }
  
  toggleDrawerNotify = () => {
    this.setState({visibleDrawerNotify: !this.state.visibleDrawerNotify});
    this.props.fetchUserNotifications(this.filter, (value) => this.setState({totalCountAll: value.totalCount}))
  }
  
  toggleViewAllNotify = () => {
    this.setState({loading: true});
    this.props.checkedAllUserNotifications({}, () => {
      this.setState({loading:false})
      this.props.fetchUserNotifications(this.filter, (value) => this.setState({totalCountAll: value.totalCount}))
      this.props.fetchMarkedNotifications(this.filter, ({totalCount}) =>  this.setState({totalCount})) 
    })
  }
  
  componentDidMount(){
    if(window.$isAuthenticated){
      this.props.fetchMarkedNotifications(this.filter, ({totalCount}) =>  this.setState({totalCount}))
    }
  }
  
  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('mousedown', this.handleClickDrawer, false);
    document.addEventListener('mousedown', this.handleClickDrawerNotify, false);
  }
  
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
    document.removeEventListener('mousedown', this.handleClickDrawer, false)
    document.removeEventListener('mousedown', this.handleClickDrawerNotify, false)
  }
  
  handleClick(e) {
    if (this.node.contains(e.target)) {
      // console.log('handleClick src/components/exchange/ExchangeSelect.js:75')
      e.preventDefault();
      return
    }
    
    // console.log('handleClick src/components/exchange/ExchangeSelect.js:79')
    this.handleClickOutside();
  }
  
  handleClickDrawer(e) {
    // if (this.drawer.contains(e.target)) {
    //   // console.log('handleClickDrawerNotify src/components/exchange/ExchangeSelect.js:83');
    //   return
    // }
    //
    // this.handleClickOutsideDrawer();
  }
  
  handleClickDrawerNotify(e) {
    if (this.drawerNotify.contains(e.target)) {
      return
    }
    
    this.handleClickOutsideDrawerNotify();
  }
  
  handleClickOutsideDrawerNotify() {
    this.setState({visibleDrawerNotify: false});
  }
  
  handleClickOutsideDrawer() {
    this.setState({visibleDrawer: false});
  }
  
  handleClickOutside() {
    this.setState({visible: false});
  }
  
  getBalance(currency) {
    return window._.get(this.props.balance[`${currency}`], 'balance', 0) || 0;
  }
  
  getAvailableBalance(currency) {
    return window._.get(this.props.balance[`${currency}`], 'available_balance', 0) || 0;
  }
  
  getSumBalance(coin, currency) {
    return 0;
  }
  
  currentSelect = () => {
    return get(this.props.mapMarkets, [this.props.currency || 'USDT', this.props.coin || 'BTC'], {});
  }

  currentSelectV2 = () => {
    return _.find(this.props.currencyMarkets[this.props.currency || 'USDT'], {'coin' : (this.props.coin || 'BTC')} )
  }

  
  render() {
    let currency = this.props.currency;
    let coin = this.props.coin;
    return (
      <Translation>
        {(t) => <div style={{textAlign: 'left'}} className="wrap-exchange-select text-normal">
          <Row>
            <Col span={4}>
              <div ref={node => this.node = node} className="ln-normal">
							<span className="text-left link uppercase" onClick={() => this.toggleMarket()}>
								{!!this.currentSelect() ? `${coin}/${currency}` : ''}
                <DownOutlined style={{marginLeft: 5}}/>
							</span>
                <span className={`op-80 uppercase custom-ellipsis ml-small mr-small text-right 
                ${isEmpty(this.currentSelectV2()?.style) ? "" : (this.currentSelectV2().style.color === "red" ? "exchange-down" : "exchange-up")}`}
                >
                {utils.formatCurrency(this.currentSelectV2()?.last_price ?? this.currentSelect().last_price)} 
                {isEmpty(this.currentSelectV2()?.style) ? "" : (this.currentSelectV2().style.color === "red" ? <ArrowDownOutlined /> : <ArrowUpOutlined />)}
                {" "}
                {currency}
							</span>
                
                <Expand
                  open={this.state.visible}
                  styles={{
                    close: {
                      position: 'absolute',
                      zIndex: 2,
                      backgroundColor: '#3d4044',
                      width: '100vw',
                    },
                    open: {
                      position: 'absolute',
                      zIndex: 2,
                      maxHeight: '80vh',
                      visibility: 'visible',
                      backgroundColor: '#3d4044',
                      width: '100vw',
                    },
                  }}
                >
                  <Row gutter={10} className="mb-medium">
                    {
                      window._.map(window._.get(this.props, 'coins', []), (({coin, name}) => {
                          if (window._.isEmpty(window._.get(this.props.markets, coin, []))) {
                            return '';
                          }
                          return <Col key={name}>
                            <div className="h4">{name}</div>
                            {
                              window._.get(this.props.markets, coin, []).map((coinIns, i) => {
                                return <div key={`${coin}_${i}`}
                                            style={{textTransform: 'uppercase'}}
                                            className="p-ex-small lh-medium uppercase list-item"
                                            onClick={() => this.handleClickItem(coinIns)}>
                                  <span className="fz-14 link">{coinIns.coin} / {coin}</span> <span className={`op-80 ${isEmpty(coinIns.style) ? "" : (coinIns.style.color === "red" ? "exchange-down" : "exchange-up")}`}>
												{coinIns.coin} {utils.formatCurrency(coinIns.last_price)} {isEmpty(coinIns.style) ? "" : (coinIns.style.color === "red" ? <ArrowDownOutlined /> : <ArrowUpOutlined />)}
											</span>
                                </div>
                              })
                            }
                          </Col>
                        }
                      ))
                    }
                  </Row>
                </Expand>
              </div>
            </Col>
            <Col xxl={16} xl={14.5} lg={14}>
              {window.$isAuthenticated ? 
              <Row gutter={10}>
                <Col span={3}/>
                <Col span={7} className="text-left">
                  <div className="fz-label uppercase ">{window.$t('exchange.exchange_select.your_balance')}</div>
                  <div
                    className="h4 uppercase ellipsis o1"
                    title={`${currency} ${utils.formatCurrency(this.getBalance(currency))} / ${coin} ${utils.formatCurrency(this.getBalance(coin))}`}> {currency}
                    <span className='bold text-white'> {utils.formatCurrency(this.getBalance(currency))}</span> / {coin}
                    <span
                      className='bold text-white'> {utils.formatCurrency(this.getBalance(coin))}</span>
                  </div>
                </Col>
                <Col span={7} className="text-left">
                  <div className="fz-label uppercase">{window.$t('exchange.exchange_select.available')}</div>
                  <div
                    className="h4 uppercase ellipsis o1"
                    title={`${currency} ${this.getAvailableBalance(currency)} / ${coin} ${utils.formatCurrency(this.getAvailableBalance(coin))}`}> {currency}
                    <span
                      className='bold text-white'> {utils.formatCurrency(this.getAvailableBalance(currency))}</span> / {coin}
                    <span className='bold text-white'> {utils.formatCurrency(this.getAvailableBalance(coin))}</span>
                  </div>
                </Col>
                <Col span={4} className="text-left">
                  <div className="fz-label uppercase">{window.$t('exchange.exchange_select.value')}</div>
                  <div className="h4 uppercase ellipsis o1"
                       title={`${coin} ${this.getBalance(coin)}`}> {coin}
                    <span className='bold text-white'> {utils.formatCurrency(this.getBalance(coin))}</span></div>
                </Col>
              </Row> : ""}
            </Col>
            <Col xxl={4} xl={5.5} lg={6}>
              <div className="text-right full-height">
                <div style={{
                  flex: 1,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: "center",
                  height: '100%',
                }}>
                  <div ref={node => this.drawerNotify = node}
                       style={{
                         display: 'flex',
                         alignItems: 'center',
                         cursor: 'pointer',
                         marginRight: 22,
                       }}>
                  {window.$isAuthenticated ? <>
                    <Badge count={this.state.totalCount}
                           overflowCount={consts.DEFAULT_BADGE_COUNT}
                           onClick={this.toggleDrawerNotify}
                    >
                      <div className="link ln-normal text-trans-none">
                      <span className="icon-bell-abc-1"
                            style={{fontSize: 25, float: 'left', marginLeft: 5}}/>
                      </div>
                    </Badge>
                    
                      <Expand
                      open={this.state.visibleDrawerNotify}
                      styles={{
                        open: {
                          position: 'absolute',
                          zIndex: 2,
                          height: window.$heightNotification,
                          top: '49px',
                          maxWidth: '500px',
                          textAlign: 'left',
                          width: '98%',
                          backgroundColor: '#36393D',
                          right: 0,
                        },
                        close: {
                          position: 'absolute',
                          zIndex: -1,
                          height: window.$heightNotification,
                          top: '49px',
                          maxWidth: '500px',
                          textAlign: 'left',
                          width: '98%',
                          backgroundColor: '#36393D',
                          right: 0,
                        }
                      }}
                    >
                      <Notification notifies={this.props.notifies} coins={this.props.coins}
                                    loading={this.state.loading}
                                    totalCount={this.state.totalCount}
                                    totalCountAll={this.state.totalCountAll}
                                    checkedUserNotifications={this.props.checkedUserNotifications}
                                    toggleViewAllNotify={this.toggleViewAllNotify}
                                    />
                    </Expand> </> : ""}
                  </div>
                  <div className='text-small'
                       style={{color: '#64afff'}}> {window.$isAuthenticated ? (this.props.info.email || this.props.info.display_name || '...' ) : ""}</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>}
      </Translation>
    
    );
  }
}

const styles = {
  listItem: {
    textTransform: 'uppercase',
    
  }
}

export default ExchangeSelect;
